import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface MetricCardProps {
  value: string;
  label: string;
  iconName: string;
  colorClass?: string;
}

export default function MetricCard({
  value,
  label,
  iconName,
  colorClass = 'bg-primary/10 text-primary',
}: MetricCardProps) {
  return (
    <div className="bg-card rounded-xl sm:rounded-2xl p-5 sm:p-6 border border-border shadow-sm hover:shadow-md transition-shadow duration-300">
      <div className={`w-10 h-10 sm:w-12 sm:h-12 rounded-full ${colorClass} flex items-center justify-center mb-3 sm:mb-4`}>
        <Icon name={iconName as any} size={20} className="sm:w-6 sm:h-6" />
      </div>
      <div className="text-3xl sm:text-4xl font-serif font-light text-foreground mb-2 tracking-tight">
        {value}
      </div>
      <div className="text-xs sm:text-sm text-muted-foreground">{label}</div>
    </div>
  );
}